import { useEffect, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from '@vgno/icons';
import cn from 'classnames';

import { Card } from '../Card/Card';

import type { FC } from 'react';

import * as styles from './CardsGallery.module.scss';

export interface CardsGalleryProps {
  cards: { name: string; image: string }[];
  selectedIndex: number;
  onSelectedIndexChange: (value: number) => void;
}

export const CardsGallery: FC<CardsGalleryProps> = ({
  cards,
  selectedIndex,
  onSelectedIndexChange,
}) => {
  const ref = useRef<HTMLLIElement>(null!);
  const [isTransitionActive, setIsTransitionActive] = useState(false);

  useEffect(() => {
    const handleTransitionStart = () => {
      setIsTransitionActive(true);
    };
    const handleTransitionEnd = () => {
      setIsTransitionActive(false);
    };

    const element = ref.current;

    element.addEventListener('transitionstart', handleTransitionStart, {
      passive: true,
    });
    element.addEventListener('transitionend', handleTransitionEnd, {
      passive: true,
    });

    return () => {
      element.removeEventListener('transitionstart', handleTransitionStart);
      element.removeEventListener('transitionend', handleTransitionEnd);
    };
  }, []);

  return (
    <ul className={styles.carousel}>
      {!isTransitionActive && (
        <button
          className={cn(styles.button, styles.left)}
          onClick={() =>
            onSelectedIndexChange(
              selectedIndex - 1 < 0 ? cards.length - 1 : selectedIndex - 1
            )
          }
        >
          <ChevronLeft />
        </button>
      )}
      {cards.map(({ name, image }, index) => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/role-supports-aria-props
        <li
          className={styles.item}
          key={index}
          ref={index === 0 ? ref : undefined}
          aria-selected={index === selectedIndex}
          style={{
            transform:
              index === selectedIndex
                ? `translate(calc(300px + 520px * ${
                    index - 1 - selectedIndex
                  })) scale(1)`
                : `translate(calc(${
                    index > selectedIndex ? '195px' : '-15px'
                  } + 310px * ${
                    index - 1 - selectedIndex
                  })) scale(calc(230 / 440))`,
          }}
          onClick={() => {
            onSelectedIndexChange(index);
          }}
        >
          <Card imageUrl={image} name={name} />
        </li>
      ))}
      {!isTransitionActive && (
        <button
          className={cn(styles.button, styles.right)}
          onClick={() =>
            onSelectedIndexChange(
              selectedIndex + 1 > cards.length - 1 ? 0 : selectedIndex + 1
            )
          }
        >
          <ChevronRight />
        </button>
      )}
      <div className={styles.pagination}>
        <div>
          {selectedIndex + 1} / {cards.length}
        </div>
      </div>
    </ul>
  );
};
